import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { Div } from '@driftt/tide-core'

import PlaybookReport from 'pages/PlaybookReports'

const PlaybookReportLayout = (match) => {
  return (
    <Div className="playbooks-reports-layout">
      <Switch>
        <Route path="/reports/playbooks/:id" component={PlaybookReport} />
      </Switch>
    </Div>
  )
}

export default PlaybookReportLayout